import * as React from 'react';
import * as ReactDOM from 'react-dom';
import configureApolloClient from './apollo/configureApolloClient';
import configureRemoteApolloLink from './apollo/configureRemoteApolloLink';
import BrowserRoot from './BrowserRoot';
import './styles/styles.scss';

// Initialize the apollo remote link and client
const apolloLink = configureRemoteApolloLink();
const apolloClient = configureApolloClient(apolloLink);

const rootComponent = <BrowserRoot apolloClient={apolloClient} />;
const rootElement = document.getElementById('root');

if (rootElement && rootElement.childElementCount) {
    // If elements have already been rendered by the server, we want
    // to pick them up by using the "hydrate" method.
    ReactDOM.hydrate(rootComponent, rootElement);
} else {
    ReactDOM.render(rootComponent, rootElement);
}



// WEBPACK FOOTER //
// ./src/client/index.tsx